export default __webpack_public_path__ + "static/media/forward-key.faefbb8b.svg";